<template>
  <div>
    <div class="login-background">
      <div class="loginBox">
        <img
          src="../assets/WellcomeImages/logoWellcome.png"
          alt="Wellcome logo"
        />
        <h3 v-if="showPasswordReset && !resetEmailSent">
          Forgot your password?
        </h3>
        <p v-if="showPasswordReset && !resetEmailSent">
          Enter your e-mail address and click reset. We will send you
          instructions on how to reset it.
        </p>
        <h3 v-if="resetEmailSent">E-mail was sent.</h3>
        <input
          v-model="email"
          placeholder="E-mail"
          type="email"
          v-if="!resetEmailSent"
        />
        <input
          v-model="password"
          placeholder="Password"
          type="password"
          v-if="
            (!showPasswordReset && !invalidCredentials) || invalidCredentials
          "
        />
        <transition name="shakeError">
          <p
            class="invalidCredentials"
            v-if="invalidCredentials && !resetEmailSent"
          >
            Invalid e-mail or password
          </p>
        </transition>
        <div class="actionButtons">
          <button-global
            size="large"
            type="positive"
            text="LOG IN"
            @eventPassed="login"
            v-if="!showPasswordReset"
          ></button-global>
          <button-global
            size="large"
            type="neutral"
            text="FORGOT PASSWORD?"
            @eventPassed="showResetInfo"
            v-if="!showPasswordReset"
          ></button-global>
          <button-global
            size="large"
            type="positive"
            text="SEND"
            @eventPassed="resetPassword"
            v-if="showPasswordReset && !resetEmailSent"
          ></button-global>
          <button-global
            size="large"
            type="positive"
            text="LOG IN"
            @eventPassed="showLogin"
            v-if="resetEmailSent"
          ></button-global>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth, db } from "@/firebase";
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";

export default {
  components: {
    ButtonGlobal,
  },
  data() {
    return {
      email: "",
      password: "",
      invalidCredentials: false,
      showPasswordReset: false,
      resetEmailSent: false,
    };
  },
  mounted: function () {
    document.addEventListener("keydown", this.shortcutLogin);
  },
  destroyed: function () {
    document.removeEventListener("keydown", this.shortcutLogin);
  },
  methods: {
    shortcutLogin(e) {
      if (e.keyCode == 13) {
        this.login();
      }
    },
    login() {
      this.invalidCredentials = false;
      this.showPasswordReset = false;
      this.resetEmailSent = false;

        auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then( userDetails => {
          return db.ref(`/users/${userDetails.user.uid}/hotel`).once("value")
        })
        .then( async hotel => {

          const token = await auth.currentUser.getIdTokenResult();

          if (token.claims.admin) {
            this.$router.replace({
              name: "hotels",
            });
          } else {
            this.$router.replace({
              name: 'event-list',
              params: { hotel: hotel.val() }
            })
          }
        })
        .catch((err) => {
          console.log(err)
          this.invalidCredentials = true;
        });
    },
    showResetInfo() {
      this.invalidCredentials = false;
      this.showPasswordReset = true;
    },
    showLogin() {
      this.invalidCredentials = false;
      this.showPasswordReset = false;
      this.resetEmailSent = false;
    },
    resetPassword() {
        auth
        .sendPasswordResetEmail(this.email)
        .then(() => {
          this.resetEmailSent = true;
        })
        .catch((err) => {
          if (err.code === "auth/user-not-found") {
            this.resetEmailSent = true;
          }
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}
.invalidCredentials {
  font-weight: 700;
  font-size: 1.2em;
  text-align: center;
  color: rgb(204, 45, 45);
  margin-top: 0px;
}
.login-background {
  background: url("../assets/WellcomeImages/loginBackground.png")
    no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
.loginBox {
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2);
  background-color: white;
  border-radius: 12px;
  width: 370px;
  padding: 40px 25px;
  margin: auto 0;
}
.loginBox > img {
  width: 100%;
}
.actionButtons div:nth-child(1) {
  margin-top: 10px;
  margin-bottom: 15px;
}
input {
  margin: 15px 0;
  width: 100%;
  background-color: #f3f2ee;
  border: 1px solid #e8e7e3;
  border-radius: 12px;
  color: #66615b;
  font-size: 16px;
  padding: 7px 18px;
  height: 50px;
}
.shakeError-enter-active {
  transition: all 0.3s ease;
}
.shakeError-enter {
  transform: translateY(-10px);
  opacity: 1;
}
</style>
